import React, { Component } from 'react'
import MImg from '@/components/img'
import querystring from 'query-string'
import { Button, List, Modal, Toast } from 'antd-mobile'
import FirstScreen from '@/views/FirstScreen/index'
import {
  copyToClip,
  getProxyConfig,
  AppList,
  getArray2Name,
  getWhiteTime,
  sensorsMonitor,
} from '@/utils/utils'
import { ApiTemporaryRepayByCo } from '@/api/'
import '@/assets/css/cash-pay.scss'
const Item = List.Item
class CashPayment extends Component {
  constructor(props) {
    super(props)
    const query = querystring.parse(window.location.search)
    const localApp = query['app'] || ''
    let app = getArray2Name(AppList, localApp)
    if (!app) {
      app = AppList[0] // 默认走印度
    }
    this.state = {
      imgModal: false,
      imgUrl: '',
      localApp,
      appRules: app,
      appData: null, // 客户端信息
      loading: false, // 等待客户端返回相应token过来才能请求接口
      cashPayData: {},
      CashPayBool: false,
    }
  }

  componentDidMount() {
    document.title = 'Pago en efectivo'
    this.sensorsInit()
    this.getAppData()
    setTimeout(() => {
      this.getCode()
    }, 80)
  }
  // 数据打点相关
  sensorsInit() {
    const SaSdk = sensorsMonitor()
    SaSdk.registerPage({
      current_url: window.location.href,
      pagename: 'h5_cash_payment',
      appName: this.state.appRules.appName,
    })
    SaSdk.quick('autoTrack')
    SaSdk.track('h5_cash_payment_pageview', {
      load_time: getWhiteTime(),
    })
  }
  // 获取app的请求头
  getAppData() {
    if (window.android) {
      const json = window.android.getRequestHeaders()
      const data = json ? JSON.parse(json) : null
      this.setState({
        appData: Object.assign({}, this.state.appData, data),
      })
    }
    // else {
    //   this.setState({
    //     appData: Object.assign({}, this.state.appData, {
    //       Authorization: 'Bearer DB5D4A3207D29410DE863924DA1EB85E2AA8E16AF2D4550AEC4DFB3308E482C1', // 尼日利亚
    //     })
    //   })
    // }
  }

  getCode() {
    const { localApp } = this.state
    const { params } = this.state.appRules
    ApiTemporaryRepayByCo({
      headers: this.state.appData,
      data: { ...params },
      ...getProxyConfig(localApp),
    })
      .then((res) => {
        this.setState({
          cashPayData: res,
          CashPayBool: true,
        })
      })
      .finally(() => {
        this.setState({
          loading: true,
        })
      })
  }

  clickCopy(content) {
    copyToClip(content) // 复制内容
    Toast.info('Se copió correctamente', 3)
  }

  handleClick(src) {
    this.setState({
      imgModal: true,
      imgUrl: src,
    })
  }

  handleOKClick() {
    if (window.android) {
      window.android.jumpToHome()
    }
  }

  htmlCashPay() {
    const { imgModal, imgUrl, CashPayBool, cashPayData } = this.state
    if (CashPayBool) {
      return (
        <div className="contend">
          <Modal
            className="am-modal_img"
            visible={imgModal}
            transparent
            maskClosable={true}
            onClose={() => this.setState({ imgModal: false })}
          >
            <MImg src={imgUrl} />
          </Modal>
          <List className="my-list">
            <Item extra={cashPayData.totalFixedFee}>Comisión</Item>
            <Item extra={cashPayData.totalRepayAmount}>
              Monto total a pagar
            </Item>
          </List>
          <h1>{cashPayData.totalRepayAmount}</h1>
          <p>Número de Referencia</p>
          <List className="list-copy">
            <Item
              onClick={() =>
                this.clickCopy(cashPayData.repayLinkMap.iGT.referenceNumber)
              }
              extra={'Copiar'}
            >
              {cashPayData.repayLinkMap.iGT.referenceNumber}
            </Item>
          </List>
          <div className="text-center">
            Presenta este comprobante en cualquiera de los puntos de pago{' '}
            <span>Red VIA Baloto</span>. Para realizar tu pago debes mencionar
            el número de Referencia{' '}
            <span>{cashPayData.repayLinkMap.iGT.referenceNumber}</span> y el
            número de Convenio <span>956701</span>.
          </div>
          <div className="img-via img-block text-center">
            <MImg
              src="/h5/img/isolez/cash-pay/4.webp"
              onClick={(src) => this.handleClick(src)}
            />
          </div>
          <div className="text-center">
            <span>Ten en cuent</span> a que los puntos de pago no realizan
            cobros adicionales por el servicio de cobranza.
          </div>
          <div className="divider">
            <span></span>
          </div>
          <p>Número de PIN para pago</p>
          <List className="list-copy">
            <Item
              onClick={() =>
                this.clickCopy(
                  cashPayData.repayLinkMap.bancoBogota.referenceNumber
                )
              }
              extra={'Copiar'}
            >
              {cashPayData.repayLinkMap.bancoBogota.referenceNumber}
            </Item>
          </List>
          <div className="img-code img-block text-center">
            <MImg src={cashPayData.repayLinkMap.bancoBogota.referenceUrl} />
          </div>
          <div className="text-center">
            Presenta este comprobante en cualquiera de los siguientes puntos de
            pago. Debes mencionar el Convenio (que encontrarás debajo de cada
            logo de la red de pago) y tu número de PIN para pagar.
          </div>
          <div className="img-block text-center">
            <MImg src="/h5/img/isolez/cash-pay/1.webp" />
          </div>
          <div className="divider">
            <span></span>
          </div>
          <p>Número de PIN para pago</p>
          <List className="list-copy">
            <Item
              onClick={() =>
                this.clickCopy(
                  cashPayData.repayLinkMap.payvalida.referenceNumber
                )
              }
              extra={'Copiar'}
            >
              {cashPayData.repayLinkMap.payvalida.referenceNumber}
            </Item>
          </List>
          <div></div>
          <div className="text-center">
            Presenta este comprobante en cualquiera de los siguientes puntos de
            pago. Debes mencionar el Convenio (que encontrarás debajo de cada
            logo de la red de pago) y tu número de PIN para pagar.
          </div>
          <div className="img-block text-center">
            <MImg src="/h5/img/isolez/cash-pay/2.webp" />
          </div>
        </div>
      )
    } else {
      return (
        <div className="no-data">
          <div className="text-center">
            <MImg src="/h5/img/isolez/cash-pay/3.webp" />
          </div>

          <p>Sin información pend</p>
          <div className="btn">
            <Button onClick={this.handleOKClick}>OK</Button>
          </div>
        </div>
      )
    }
  }

  render() {
    const renderHtml = this.htmlCashPay()
    const { loading } = this.state
    return (
      <div className="cash-pay">
        {loading ? renderHtml : <FirstScreen></FirstScreen>}
      </div>
    )
  }
}

export default CashPayment
